// Single source of truth for rooms, prices and availability — used by HomePage, RoomsPage, WaitlistSignup, SaviQuiz.
export const NEXT_OPENING = "15 December";
export const WHATSAPP = "https://wa.me/34632628051";
export const TAX_NOTE = "Prices are per month and exclude Spanish VAT (IVA). Before you commit, Steve confirms your exact total, the 30% deposit and payment dates in writing — no surprises.";

// Last-minute opening. Update or remove once booked.
export const LAST_MINUTE = {
  room: "Sky Room",
  dates: "from 15 December",
  datesShort: "from 15 Dec",
  line: "1 Sky Room left from 15 Dec — Christmas in the sun 🎅",
  whatsappUrl: `${WHATSAPP}?text=${encodeURIComponent("Hi Steve! I'd like to grab the last Sky Room from 15 December.")}`,
};

export const AWARD = {
  status: "Winner",
  category: "Best Destination Coliving",
  body: "Coliving Awards",
  year: "2026",
};

export const ROOMS = [
  {
    id: "garden",
    name: "Single Room – Garden",
    shortName: "Garden Room",
    note: "Ground floor, quiet, by the pool",
    description: "Nestled near the pool under tall pine trees, the Garden Rooms offer peace, privacy, and a soft connection to the villa's natural rhythm.",
    price: 1200,
    available: "Fully booked · short gaps sometimes open",
    availableFrom: "Fully booked · short gaps sometimes open — ask Steve",
    images: [
      "https://static.wixstatic.com/media/447ef7_a7112dc842e742219a0a65e143a4e71f~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/447ef7_a7112dc842e742219a0a65e143a4e71f~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_5c9d290dc3a24769a660b1582425dae2~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/7c2ee1_5c9d290dc3a24769a660b1582425dae2~mv2.jpg"
    ],
    features: ["Private bathroom", "Garden views", "Near pool"],
    badge: "Popular"
  },
  {
    id: "sky",
    name: "Single Room – Sky",
    shortName: "Sky Room",
    note: "Best light, most requested",
    description: "Light-filled and minimal, opening directly onto the 200sqm Sky Terrace overlooking the valley, Valencia, and the Mediterranean. Three Sky Rooms — two with shared bathroom (from €1,300), one with private ensuite (€1,400). One of the most asked-for rooms in the villa.",
    price: 1300,
    available: "From 15 December · last one left",
    urgent: true,
    availableFrom: "From 15 December · the last Sky Room left",
    images: [
      "/img/sky-terrace-1080.webp",
      "https://static.wixstatic.com/media/7c2ee1_8d05bd7580cd41aa92d3bb2254ff1d5d~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/7c2ee1_8d05bd7580cd41aa92d3bb2254ff1d5d~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_12e3c0cc65064ab4ace03fbd4583e156~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/7c2ee1_12e3c0cc65064ab4ace03fbd4583e156~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_b9a13bb9d35d4a7db1f98931c66648f7~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/7c2ee1_b9a13bb9d35d4a7db1f98931c66648f7~mv2.jpg"
    ],
    features: ["200sqm Sky Terrace", "Sea & Valencia views", "Shared or ensuite bathroom"],
    badge: "Most Requested"
  },
  {
    id: "panorama",
    name: "Private Double – Panorama",
    shortName: "Panorama Double",
    note: "Main house, sweeping views",
    description: "Located in the main house with sweeping views, this private double offers comfort, privacy, and space to recharge.",
    price: 1350,
    available: "From 19 December",
    availableFrom: "Available from 19 December",
    images: [
      "https://static.wixstatic.com/media/447ef7_ad8ceeec2bf34d59b755b058a10b571b~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/447ef7_ad8ceeec2bf34d59b755b058a10b571b~mv2.jpg",
      "https://static.wixstatic.com/media/447ef7_ea90f6ab15de4664816d5de6458226bf~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/447ef7_ea90f6ab15de4664816d5de6458226bf~mv2.jpg",
      "https://static.wixstatic.com/media/447ef7_fdc7e16ad852445d89385944928c0401~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/447ef7_fdc7e16ad852445d89385944928c0401~mv2.jpg"
    ],
    features: ["Double bed", "Private bathroom", "Main house"],
    badge: null
  },
  {
    id: "tower",
    name: "Private Double – Tower",
    shortName: "Tower Room",
    note: "Top of the villa, total privacy",
    description: "Perched at the very top of the villa, this private double has sweeping views and total privacy — a quiet retreat for couples or solo travelers.",
    price: 1450,
    available: "Fully booked",
    availableFrom: "Fully booked — join the waitlist",
    images: [
      "https://static.wixstatic.com/media/7c2ee1_5c38eba8232b4da9a42c9da01b2bd84f~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/7c2ee1_5c38eba8232b4da9a42c9da01b2bd84f~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_ff67404917324fb59fdacf3fc7e18bd7~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/7c2ee1_ff67404917324fb59fdacf3fc7e18bd7~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_53019ba4fa3f430985b30d812e937d25~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/7c2ee1_53019ba4fa3f430985b30d812e937d25~mv2.jpg"
    ],
    features: ["Double bed", "Private bathroom", "Top floor", "Best views"],
    badge: "Premium"
  },
  {
    id: "baylight",
    name: "Junior Suite (Baylight) with Terrace",
    shortName: "Junior Suite",
    note: "Private sun terrace, west-facing",
    description: "Facing west toward the Mediterranean, this spacious suite includes a private sun terrace — perfect for slow evenings and longer stays.",
    price: 1450,
    available: "From 23 December",
    availableFrom: "Available from 23 December",
    images: [
      "https://static.wixstatic.com/media/7c2ee1_b0736b78d4b947a8869ee52580cdb9b9~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/7c2ee1_b0736b78d4b947a8869ee52580cdb9b9~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_07981c92215e43348ff67f4281c095c3~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/7c2ee1_07981c92215e43348ff67f4281c095c3~mv2.jpg",
      "https://static.wixstatic.com/media/447ef7_1abfc85ca2c94057b6e565b376007368~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/447ef7_1abfc85ca2c94057b6e565b376007368~mv2.jpg"
    ],
    features: ["Private terrace", "Sunset views", "Spacious"],
    badge: "Best Value"
  },
  {
    id: "large-suite",
    name: "Luxury Suite (Panorama)",
    shortName: "Luxury Suite",
    note: "Spacious panorama, for longer stays",
    description: "Grounded and generous, the Large Suite has space to stretch, create, and rest. Ideal for couples or solo travelers planning a longer journey.",
    price: 1700,
    available: "Fully booked",
    urgent: false,
    availableFrom: "Fully booked — join the waitlist",
    images: [
      "https://static.wixstatic.com/media/447ef7_673917bb40a94da8984c32b86922e733~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/447ef7_673917bb40a94da8984c32b86922e733~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_e127098284b145f2aa4b72abcb60599a~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/7c2ee1_e127098284b145f2aa4b72abcb60599a~mv2.jpg",
      "https://static.wixstatic.com/media/447ef7_fdc7e16ad852445d89385944928c0401~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/447ef7_fdc7e16ad852445d89385944928c0401~mv2.jpg"
    ],
    features: ["Extra large", "Work desk", "Premium bathroom"],
    badge: "Premium"
  },
  {
    id: "apartment",
    name: "Sunny Apartment with Kitchen",
    shortName: "Apartment",
    note: "Private kitchen, independence",
    description: "Our largest private unit, complete with a kitchenette, study, bedroom, and balcony. Perfect for those who want autonomy while staying connected to the Savi community.",
    price: 2100,
    available: "Fully booked",
    availableFrom: "Fully booked — join the waitlist",
    images: [
      "https://static.wixstatic.com/media/447ef7_b7dcfc48e621473d82877917795cfd00~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/447ef7_b7dcfc48e621473d82877917795cfd00~mv2.jpg",
      "https://static.wixstatic.com/media/447ef7_41d07f87c3c54bfaa4cc81ae2f58b20a~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/447ef7_41d07f87c3c54bfaa4cc81ae2f58b20a~mv2.jpg",
      "https://static.wixstatic.com/media/447ef7_8ea767ca301943c497de41a6caf949e2~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/447ef7_8ea767ca301943c497de41a6caf949e2~mv2.jpg"
    ],
    features: ["Kitchenette", "Study area", "Balcony", "Full autonomy"],
    badge: null
  }
];

export const formatPrice = (n) => `€${n.toLocaleString("en-GB")}`;
